import React, { useMemo } from "react";
import ReefBackgroundSVG from "./ReefBackgroundSVG";
import Lottie from "lottie-react";

import fishFront from "./fishFront.json";
import fishFrontWide from "./fishFrontWide.json";

import CoralLeftSVG from "./CoralLeftSVG";
import CoralRightSVG from "./CoralRightSVG";

const gradientreef = ["#0191FB", "#03AC9E", "#03B3A9"];

const gradientfront = [
  "rgba(1,145,251,0)",
  "rgba(1,145,251,.8)",
  "rgba(3,172,158,.7)",
  "rgba(3,179,169,0.0)",
];

function ReefContent({ withfish, width, height, children, noback, style }) {
  const aspect = height / width;

  const containerStyle = useMemo(
    () => ({
      position: "relative",
      overflow: "hidden",
      width: "100%",
      height: "100%",
      display: "block",
      ...(style || {}),
    }),
    [style],
  );

  const coralWidth = Math.min(height*.1,width * 0.15)

  return (
    <div style={containerStyle}>
      {/* Background SVG */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          pointerEvents: "none",
          zIndex: 0,
        }}
      >
        <ReefBackgroundSVG
          width={width*1.5}
          height={height}
          noback={noback}
        />
      </div>

      {/* Front gradient haze */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          paddingTop: height * 0.2,
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: `linear-gradient(to bottom, ${gradientfront.join(",")})`,
          }}
        />
      </div>

      {/* Turtle back */}
      {/* {withfish ? (
        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            zIndex: 1,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: height < width ? -height * 0.2 : height * 0.05,
              width: height < width ? width : width * 1.2,
            }}
          >
            <div style={{ width: height < width ? width : width * 1.2 }}>
              <Lottie animationData={turtleBack} loop autoplay style={{ width: "100%" }} />
            </div>
          </div>
        </div>
      ) : null} */}

      {/* Left coral */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          paddingTop: height * 0.3,
          opacity: 0.5,
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        <CoralLeftSVG width={coralWidth} />
      </div>

      {/* Right coral */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          paddingTop: height * 0.4,
          opacity: 0.5,
          right:0,
          display: "flex",
          justifyContent: "flex-end",
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        <CoralRightSVG width={coralWidth} />
      </div>

      {/* Foreground content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          height: "100%",
        }}
      >
        {children}
      </div>

      {/* Fish front */}
      {withfish ? (
        <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 3 }}>
          <div style={{ position: "absolute", bottom: 0, width: "100%" }}>
            <Lottie animationData={
              width>height ? fishFrontWide :
              fishFront} loop autoplay style={{ width: "100%" }} />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default function ReefBackground({ width, height, children, withfish, noback, style }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: `linear-gradient(to bottom, ${gradientreef.join(",")})`,
      }}
    >
      <ReefContent
        width={width}
        height={height}
        noback={noback}
        style={style}
        withfish={withfish}
      >
        {children}
      </ReefContent>
    </div>
  );
}
